"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialUrl = exports.defaultUser = exports.authRole = void 0;
var AppEnums_1 = require("./AppEnums");
exports.authRole = {
    admin: ['admin'],
    user: ['user', 'admin'],
};
exports.defaultUser = {
    uid: 'RFedvhji876rfhjuecvh7',
    displayName: 'John Alex',
    email: 'demo@example.com',
    token: 'access-token',
    role: exports.authRole.user,
    authType: AppEnums_1.AuthType.AUTH0,
    photoURL: '/assets/images/avatar/A11.jpg',
};
exports.initialUrl = '/dashboard'; // this url will open after login
//# sourceMappingURL=AppConst.js.map